import { render, staticRenderFns } from "./CotizacionDetails.vue?vue&type=template&id=7bc971db"
import script from "./CotizacionDetails.vue?vue&type=script&lang=js"
export * from "./CotizacionDetails.vue?vue&type=script&lang=js"
import style0 from "./CotizacionDetails.vue?vue&type=style&index=0&id=7bc971db&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCardText,VCol,VImg,VResponsive,VRow,VSelect})
